import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../auth/AuthContext';
import { fetchWithAuth } from '../utils/fetchWithAuth';

/**
 * Usage:
 *  - <ProtectedRoute> ... </ProtectedRoute>                       // any logged-in role
 *  - <ProtectedRoute requiredRole="coach"> ... </ProtectedRoute>  // exactly one role
 *  - <ProtectedRoute allowedRoles={['coach','player']}> ... </ProtectedRoute> // multiple roles
 */
const ProtectedRoute = ({ children, requiredRole, allowedRoles }) => {
  const { token, role, accountId } = useContext(AuthContext);

  if (!token) {
    return <Navigate to="/" replace />;
  }

  // exact single-role guard (backward compatible)
  if (requiredRole && role !== requiredRole) {
    return role === 'coach'
      ? <Navigate to="/coachdashboard" replace />
      : <Navigate to={`/player/${accountId}`} replace />;
  }

  // multi-role guard
  if (allowedRoles && !allowedRoles.includes(role)) {
    return role === 'coach'
      ? <Navigate to="/coachdashboard" replace />
      : <Navigate to={`/player/${accountId}`} replace />;
  }

  return children;
};

export default ProtectedRoute;
